import { css } from '@emotion/react'
import styled from '@emotion/styled'

const StyledRadio = styled.input(() => [
  css`
    appearance: none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    line-height: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &:before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 1px solid var(--primary-color);
      border-radius: 50%;
    }
    &:after {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: block;
      position: absolute;
      transform: scale(0);
      transition: 100ms transform ease-in-out;
      background-color: var(--primary-color);
    }
    &:checked:after {
      transform: scale(1);
    }
  `
])

export default StyledRadio
